import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import MarkerClusterGroup from "react-leaflet-markercluster";

// Custom marker icon (Leaflet requires explicit setup for marker icons)
const DefaultIcon = L.icon({
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  iconSize: [30, 45],
  iconAnchor: [15, 45],
  popupAnchor: [0, -40],
});

// Define user data
type User = {
  id: number;
  name: string;
  location: { lat: number; lng: number };
};

const users: User[] = [
  { id: 1, name: "User 1 (San Francisco)", location: { lat: 37.7749, lng: -122.4194 } },
  { id: 2, name: "User 2 (Los Angeles)", location: { lat: 34.0522, lng: -118.2437 } },
  { id: 3, name: "User 3 (New York)", location: { lat: 40.7128, lng: -74.0060 } },
  { id: 4, name: "User 4 (Mumbai)", location: { lat: 19.0760, lng: 72.8777 } },
  { id: 5, name: "User 5 (Pune)", location: { lat: 18.5204, lng: 73.8567 } },
  { id: 6, name: "User 6 (Nagpur)", location: { lat: 21.1458, lng: 79.0882 } },
];

const MultiuserLocationTracking: React.FC = () => {
  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-12">
          <h1 className="text-center mb-3">Multi-User Location Tracking</h1>
          <div
            className="rounded shadow"
            style={{
              overflow: "hidden",
              border: "2px solid #ddd",
            }}
          >
            <MapContainer
              center={[20.5937, 78.9629]} // Center map on India
              zoom={5} // Adjusted zoom for better view 
              style={{
                height: "80vh",
                width: "100%",
              }}
              //scrollWheelZoom={false} // Disable scroll zoom
            >
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
               // attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              />

              {/* Marker Cluster Group to group markers */}
              <MarkerClusterGroup>
                {users.map((user) => (
                  <Marker key={user.id} position={[user.location.lat, user.location.lng]} icon={DefaultIcon}>
                    <Popup>
                      <div className="text-center">
                        <h5>{user.name}</h5>
                        <p>
                          <strong>Location:</strong><br />
                          Lat: {user.location.lat}, Lng: {user.location.lng}
                        </p>
                      </div>
                    </Popup>
                  </Marker>
                ))}
              </MarkerClusterGroup>
            </MapContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MultiuserLocationTracking;
